enum QUALITY_CONTROL_KEYS {
  casesTable = 'casesTable',
  defects = 'defects',
  carpetChart = 'carpetChart',
}

const QUALITY_CONTROL_NAMES: { [section in QUALITY_CONTROL_KEYS]: string } = {
  casesTable: 'Cases Table',
  defects: 'Defects',
  carpetChart: 'Carpet Chart',
}

const QUALITY_CONTROL_PATHS: { [section in QUALITY_CONTROL_KEYS]: string } = {
  casesTable: '/quality-control/cases',
  defects: '/quality-control/defects',
  carpetChart: '/quality-control/carpet-chart',
}

export { QUALITY_CONTROL_KEYS, QUALITY_CONTROL_NAMES, QUALITY_CONTROL_PATHS }
